// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"96f9523c","433":"7caa44ea","595":"647863fa"}[chunkId] + ".chunk.css";
};